import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * ThemeWrapper - Applies theme to entire app
 * Wraps children with theme-aware background and text colors
 */
export default function ThemeWrapper({ children }) {
  const { theme } = useTheme();

  return (
    <div style={{
      minHeight: '100vh',
      background: theme.colors.bg.primary,
      color: theme.colors.text.primary,
      transition: 'background-color 0.3s ease, color 0.3s ease'
    }}>
      {children}
    </div>
  );
}

